import { browser } from './$_functions.js'

export var app = {
	loader: function() {
		browser.ie()
	},
}

window.addEventListener('load', function() {
	// init on load
	app.loader()
})
